import React from "react";

const HowWeDoItCard = ({
  steps = [],
  variant = "light", // 'light' (soft mint), 'white' (white with shadow), 'dark' (on green background)
}) => {
  const cardBgClasses =
    variant === "white"
      ? "bg-white border border-gray-100 shadow-sm"
      : variant === "dark"
      ? "bg-white border border-white/20 shadow-md"
      : "bg-[#F4F9F6] border border-gray-100/80";

  return (
    <div
      className={`w-full max-w-2xl rounded-[22px] p-6 sm:p-8 transition-shadow duration-300 hover:shadow-md ${cardBgClasses}`}
    >
      <h3 className="text-xs sm:text-sm font-bold tracking-wider uppercase text-gray-900 mb-6 font-['Axiforma',sans-serif]">
        HOW WE DO IT
      </h3>

      <div className="flex flex-col space-y-4 sm:space-y-4.5">
        {steps.map((step, index) => (
          <div key={index} className="flex items-start gap-3.5 sm:gap-4">
            <span className="w-6 h-6 rounded-full bg-[#1E6C56] text-white flex items-center justify-center text-xs font-bold shrink-0 mt-0.5 select-none">
              {index + 1}
            </span>
            <p className="text-xs sm:text-sm text-[#374151] leading-relaxed font-medium">
              {step}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowWeDoItCard;
